if (!customElements.get('zelink-product-gallery')) {
  customElements.define('zelink-product-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.galleryBound) return;
      this.galleryBound = true;
      this.abort = new AbortController();
      this.track = this.querySelector('[data-zpg-track]');
      this.slides = [...this.querySelectorAll('[data-zpg-slide]')];
      this.thumbs = [...this.querySelectorAll('[data-zpg-index]')];
      this.previous = this.querySelector('[data-zpg-prev]');
      this.next = this.querySelector('[data-zpg-next]');
      this.counter = this.querySelector('[data-zpg-count]');
      this.current = 0;
      const options = { signal: this.abort.signal };
      this.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-zpg-index]');
        if (thumb && this.contains(thumb)) {
          event.preventDefault();
          this.goTo(Number(thumb.dataset.zpgIndex));
        } else if (event.target.closest('[data-zpg-prev]')) {
          this.goTo(this.current - 1);
        } else if (event.target.closest('[data-zpg-next]')) {
          this.goTo(this.current + 1);
        }
      }, options);
      this.addEventListener('keydown', (event) => {
        const thumb = event.target.closest('[data-zpg-index]');
        if (event.target !== this.track && !thumb) return;
        let index = thumb ? Number(thumb.dataset.zpgIndex) : this.current;
        if (event.key === 'ArrowRight') index += 1;
        else if (event.key === 'ArrowLeft') index -= 1;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this.slides.length - 1;
        else return;
        event.preventDefault();
        index = Math.max(0, Math.min(this.slides.length - 1, index));
        this.goTo(index);
        if (thumb) this.thumbs[index]?.focus({ preventScroll: true });
      }, options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.syncFromScroll());
      }, { ...options, passive: true });
      this.resizeObserver = new ResizeObserver(() => {
        cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = requestAnimationFrame(() => this.goTo(this.current, false));
      });
      this.resizeObserver.observe(this.track);
      this.syncFromScroll();
    }

    goTo(index, animate = true) {
      const target = Math.max(0, Math.min(this.slides.length - 1, index));
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({
        left: this.slides[target].offsetLeft,
        behavior: animate && !reducedMotion ? 'smooth' : 'auto'
      });
      if (!animate) this.update(target);
    }

    syncFromScroll() {
      const trackBox = this.track.getBoundingClientRect();
      const center = trackBox.left + trackBox.width / 2;
      let closest = 0;
      let distance = Infinity;
      this.slides.forEach((slide, index) => {
        const box = slide.getBoundingClientRect();
        const delta = Math.abs(box.left + box.width / 2 - center);
        if (delta < distance) {
          distance = delta;
          closest = index;
        }
      });
      this.update(closest);
    }

    update(index) {
      this.current = index;
      this.previous.disabled = index === 0;
      this.next.disabled = index === this.slides.length - 1;
      this.thumbs.forEach((thumb, position) => {
        if (position === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      this.slides.forEach((slide, position) => {
        const hidden = position !== index;
        slide.setAttribute('aria-hidden', String(hidden));
        slide.inert = hidden;
        if (hidden) slide.querySelectorAll('video').forEach(video => video.pause());
      });
      const count = this.dataset.countTemplate
        .replace('__CURRENT__', String(index + 1))
        .replace('__TOTAL__', String(this.slides.length));
      if (this.counter.textContent !== count) this.counter.textContent = count;
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.scrollFrame);
      cancelAnimationFrame(this.resizeFrame);
      this.querySelectorAll('video').forEach(video => video.pause());
      this.galleryBound = false;
    }
  });
}
